import { useAppDispatch, useAppSelector } from "app/hooks"
import { setDailyCaloriesMode } from "../profileSlice"
import { IDailyCaloriesMode } from "../profileTypes"

const useUserPreferences = () => {
  const userPreferences = useAppSelector(
    (state) => state.profile.userPreferences,
  )

  const dispatch = useAppDispatch()

  const onChangeDailyCaloriesMode = () => {
    const currentMode = userPreferences.dailyCaloriesMode
    const nextMode =
      currentMode === IDailyCaloriesMode.INTAKE
        ? IDailyCaloriesMode.REMAINING
        : IDailyCaloriesMode.INTAKE

    dispatch(setDailyCaloriesMode(nextMode))
  }

  return {
    userPreferences,
    onChangeDailyCaloriesMode,
  }
}

export default useUserPreferences
